// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPaw Online Screen Recorder',
  RecordScreenWithAudio:
    'Record entire screen, an application window, or browser tab with audio',
  ScreenOnly: 'Screen Only',
  ScreenAndCam: 'Screen & Webcam',
  Microphone: 'Microphone',
  SystemAudio: 'System Audio',
  StartRecording: 'Start Recording',
  NoAudioAndTryAgain:
    'No audio source available. Please follow <1><0>the instructions</0></1> below and try again.',
  TheInstruction: 'the instructions',
  AccessMicrophone:
    'online.hitpaw.com need to access your Microphone to record audio, please click Allow!',
  BestScreenRecorderSoftware:
    'Best Screen Recorder & Free Video Streaming Software',
  CaptureAnythingOnScreen:
    'Capture and record your websites, lectures, video calls, and anything on screen',
  RecordToShare: 'Record your gameplay highlights to share with friends',
  StreamOnFackbook: 'Stream on Facebook, YouTube, Twitch, etc. like a pro',
  BringMagic: 'Bring magic virtual webcam to live streams and video chats',
  StepOne: 'Step1: Choose the screen you want to record.',
  StepTwo: 'Step2: Choose the screen you want to record.',
  StepThree: 'Step3: Click“Share system audio”.',
  StepFour: 'Step2: Click “Share”and start recording.',
  GrantPermission:
    'Please grant permission for screen recording and try again.',
  RecordingProgress: 'Recording in progress...',
  MoreOptions: 'More Recording Options:',
  Pause: 'Pause',
  Continue: 'Continue',
  Stop: 'Stop',
  Webcam: 'Webcam',
  GreenScreenAndChangeBackground: 'Green Screen & Change Background',
  StreamToYouTube: 'Stream to Facebook, Twitch, YouTube, etc.',
  ScheduleRecording: 'Schedule Recording',
  NewRecording: 'New Recording',
  ExportToMp4: 'Export to MP4',
  AddWatermark: 'Add Watermark',
  ChangeSpeed: 'Change Speed',
  CutAndTrim: 'Cut & Trim',
  '120XDownload': '120X Faster Video Converter & HD Video Downloader',
  CovertAudioFormats: 'Convert video and audio files to 1000+ formats',
  DownloadVideoFromWebsites:
    'Download and save videos from 10000+ video sharing websites',
  BatchConvertImageAndGif: 'Batch convert images and create GIFs from videos',
  RichEdingingFeatures:
    'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  BestVideoEditor: 'Best Video Editor Designed for Multi-Purposes',
  MakeSimpleEdits:
    'An award-winning video editor to make complex edits simple.',
  BeyondImaginationMaterials:
    'Varous built-in and online materials beyond imagination.',
  AqualityVideoMaker:
    'A quality-oriented video maker to export and share 1080P/4K videos completely free.',
  WorkOnAnywhere:
    'Works well and safely on any PC without affecting its performance.',
  RecordCompleted: 'Recording Completed',
  YouMayNeed: 'You May Need',
  TryItFree: 'Try It Free',
  AlreadyHaveAccount: 'هل لديك حساب ؟',
  LoginNow: 'تسجيل الدخول الآن',
  exceedTenMin: 'الوقت قد انتهى للتسجيل لمدة 10 دقائق.',
  UpgradeToRecord: 'ترقية لمواصلة التسجيل.',
  ScreenProFeature: 'ميزات مسجل الشاشة أون لاين HitPaw Pro.',
  FreeScreenAccount:
    'الحساب المجاني لديه <1><0>10</0></1> دقائق فقط لتسجيل الشاشة.',
  BuyNow: 'اشتري الآن',
  DownloadMp4: 'تنزيل بصيغة MP4',
  FreeDownload: 'تنزيل مجاني',
  Download: 'تنزيل',
  DownloadTenMin: 'تحميل 10 دقائق',
  FullVideo: 'فيديو كامل',
  FormatMp4: 'تنزيل بصيغة MP4',
  Downloading: 'جارى التنزيل...',
  DownloadFailed: 'فشل في التنزيل ، يرجى المحاولة مرة أخرى.',
  DownloadSuccess: 'تنزيل بنجاح!',
  Exceed100MDownloadConvert:
    'لا يمكن أن يتجاوز 100MB حجم الفيديو الذي نزله بتنسيق MP4 . قم بتنزيل HitPaw Video Converter لمزيد من الميزات.',
  Exceed30Min:
    'لا يمكن أن تتجاوز 30 دقيقة مدة الفيديو الذي نزله بتنسيق MP4 . قم بتنزيل HitPaw Video Converter لمزيد من الميزات.',
  Week: 'أسبوعي',
  Month: 'شهري',
  Year: 'سنوي',
  BilledMonthly: 'شهريًا',
  BilledAnnually: 'سنويًا',
  ConvertText1: 'قم بتنزيلبرنامج سطح المكتب لمعالجة ملفات كبيرة بدون حدود',
  ConvertText2:
    'دفعة تحويل ملفات الفيديو والصوت إلى 1000+ صيغة بسرعة 120x سرعة أسرع',
  ConvertText3:
    'قم بتنزيل وحفظ الفيديو من 10000+ ويب مثل يوتيوب وتيك توك والانستقرام وإلخ.',
  ConvertText4:
    'إزالة DRM من Apple Music وتحويل إلى MP3 بلا خسارة (إصدار Windows فقط)',
  TenMinUp: 'الوقت قد انتهى للتسجيل لمدة 10 دقائق.',
  UpgradeMore: 'ترقية لمواصلة التسجيل.',
  NoRecordLimit: 'لا يوجد حد لزمان تسجيل الشاشة',
  NoRecordNumLimit: 'لا يوجد حد لعدد تسجيل الشاشة',
  DownloadVideoMP4: 'تنزيل الفيديو بصيغة MP4',
  MonthOff: '60% OFF',
  YearOff: '80% OFF',
  UpgradeNow: 'ترقية فورية',
  CheckConnect: 'تحقق من الاتصال بالانترنت وحاول مرة أخرى .',
};
